{
  "familyId": "MET-INH-SCHATTEN",
  "questions": [
    {
      "id": "MET-INH-SCHATTEN-001",
      "familyId": "MET-INH-SCHATTEN",
      "module": "Metriek",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "inhoud",
      "subSkill": "inhoud_schatten",
      "questionType": "estimation_slider",
      "question": "Schat hoeveel liter water er in een badkuip past.",
      "context": null,
      "options": [],
      "correctAnswer": 0,
      "data": {
        "min": 0,
        "max": 500,
        "correctValue": 150,
        "tolerancePercent": 15,
        "unit": "liter",
        "showNumberLine": true,
        "showValue": false
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "measuringCup",
          "showWhen": "wrong",
          "data": {
            "maxVolume": 1000,
            "currentVolume": 250,
            "unit": "ml",
            "label": "Een glas water = 250 ml. Een badkuip = 600 glazen = ~150 liter."
          }
        },
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Referentiepunten voor inhoud",
            "content": "Gebruik bekende voorwerpen als referentie:\n• Glas water ≈ 250 ml\n• Fles water ≈ 1,5 liter\n• Emmer ≈ 10 liter\n• Badkuip ≈ 150 liter\n• Zwembad ≈ 50.000 liter\nElk niveau is ongeveer 10× zo groot als het vorige.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "inhoud_schatten_badkuip",
      "variantIndex": 1,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "Een badkuip bevat ongeveer 150 liter water. Hoe kun je dat schatten? Denk aan een emmer van 10 liter — je hebt er 15 nodig om een bad te vullen. Of denk aan flessen van 1,5 liter: dat zijn er 100.",
        "solutionSteps": [
          "Denk aan een referentiepunt: een emmer is ~10 liter",
          "Schat hoeveel emmers in een badkuip passen: ~15 emmers",
          "Bereken: 15 × 10 = 150 liter",
          "Controleer: 150 liter past tussen emmer (10 l) en zwembad (50.000 l) ✓"
        ]
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "met.inhoud-referentie-badkuip-fout", "label": "Schat badkuip-inhoud verkeerd in (te klein of te groot)" }
        ]
      }
    },
    {
      "id": "MET-INH-SCHATTEN-002",
      "familyId": "MET-INH-SCHATTEN",
      "module": "Metriek",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "inhoud",
      "subSkill": "inhoud_schatten",
      "questionType": "multiple_choice",
      "question": "Welke eenheid past het best bij de inhoud van een kopje thee?",
      "context": null,
      "options": ["Liter (l)", "Deciliter (dl)", "Milliliter (ml)", "Kubieke meter (m³)"],
      "correctAnswer": 2,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Welke eenheid waarvoor?",
            "content": "Milliliter = kleine hoeveelheden (kopje, glas, medicijn).\nDeciliter = middelgroot (beker, maatbeker).\nLiter = grote hoeveelheden (fles, emmer, pak melk).\nKubieke meter = heel groot (zwembad, watertank).\nKies de eenheid waarbij je een handig getal krijgt.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "inhoud_schatten_eenheid",
      "variantIndex": 2,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.77,
      "feedback": {
        "explanationText": "Een kopje thee bevat ~150-200 ml. Milliliter is de juiste eenheid voor kleine hoeveelheden vloeistof. Waarom niet deciliter? Dat kan ook (1,5-2 dl), maar milliliter is het meest precies en gebruikelijk bij recepten en verpakkingen. Waarom niet liter? Dan krijg je 0,15-0,2 liter — een onhandig getal.",
        "solutionSteps": [
          "Schat de inhoud van een kopje thee: ~150-200 ml",
          "Beoordeel elke eenheid: ml geeft een handig getal (150-200)",
          "Liter zou 0,15-0,2 l geven — onhandig klein getal",
          "Milliliter is het meest precies en gebruikelijk ✓"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat liter een goede eenheid is. Maar een kopje is ~0,15 liter — dat is een onhandig getal met komma's. Onthoud: kies de eenheid die het handigste getal geeft.",
          "1": "Je dacht waarschijnlijk aan deciliter. Dat kan (~1,5-2 dl), maar milliliter is gebruikelijker en preciezer voor kleine hoeveelheden. Onthoud: ml is standaard voor kleine vloeistoffen.",
          "2": "Goed! Milliliter is de beste eenheid voor een kopje thee (~150-200 ml). Je krijgt een handig, precies getal.",
          "3": "Je dacht waarschijnlijk aan kubieke meter. Maar m³ is voor enorme hoeveelheden (zwembaden, tanks). Een kopje is ~0,00015 m³ — een absurd klein getal!"
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "met.inhoud-eenheid-te-groot", "label": "Kiest liter voor een kleine hoeveelheid", "optionIndex": 0 },
          { "id": "met.inhoud-eenheid-deciliter-default", "label": "Kiest deciliter terwijl ml gebruikelijker is", "optionIndex": 1 },
          { "id": "met.inhoud-eenheid-veel-te-groot", "label": "Kiest m³ voor een kopje", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "MET-INH-SCHATTEN-003",
      "familyId": "MET-INH-SCHATTEN",
      "module": "Metriek",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "inhoud",
      "subSkill": "inhoud_schatten",
      "questionType": "multiple_choice",
      "question": "Een pak melk bevat 1 liter. Hoeveel glazen van 200 ml kun je daaruit schenken?",
      "context": null,
      "options": ["10 glazen", "5 glazen", "2 glazen", "20 glazen"],
      "correctAnswer": 1,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "measuringCup",
          "showWhen": "wrong",
          "data": {
            "maxVolume": 1000,
            "currentVolume": 200,
            "unit": "ml",
            "label": "Een glas = 200 ml. 1 liter = 1.000 ml. Hoeveel glazen passen erin?"
          }
        },
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Liters en milliliters",
            "content": "1 liter = 1.000 ml. Om te berekenen hoeveel glazen erin passen: deel het totaal door de inhoud per glas. 1.000 ml ÷ 200 ml = 5 glazen.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "inhoud_schatten_glazen",
      "variantIndex": 3,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "1 liter = 1.000 ml. Elk glas is 200 ml. Om te weten hoeveel glazen erin passen, deel je: 1.000 ÷ 200 = 5 glazen. Waarom delen? Omdat je wilt weten hoeveel keer 200 ml in 1.000 ml past. Controleer: 5 × 200 = 1.000 ml = 1 liter ✓",
        "solutionSteps": [
          "Reken om: 1 liter = 1.000 ml",
          "Deel door de inhoud per glas: 1.000 ÷ 200 = 5",
          "Antwoord: 5 glazen",
          "Controleer: 5 × 200 = 1.000 ml ✓"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat elk glas 100 ml bevat. Maar het glas is 200 ml. 1.000 ÷ 200 = 5 glazen, niet 10. Onthoud: lees goed hoeveel ml per glas.",
          "1": "Goed! 1.000 ÷ 200 = 5 glazen. Controleer: 5 × 200 = 1.000 ml ✓",
          "2": "Je dacht waarschijnlijk dat elk glas 500 ml (een halve liter) bevat. Maar het glas is 200 ml: 1.000 ÷ 200 = 5 glazen. Onthoud: 200 ml is een normaal drinkglas.",
          "3": "Je dacht waarschijnlijk dat elk glas 50 ml bevat. Maar 50 ml is een shotglaasje — veel te klein. Het glas is 200 ml: 1.000 ÷ 200 = 5 glazen."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "met.inhoud-glasinhoud-verkeerd", "label": "Leest glasinhoud verkeerd af (100 ml)", "optionIndex": 0 },
          { "id": "met.inhoud-glasinhoud-overschat", "label": "Denkt dat een glas 500 ml is", "optionIndex": 2 },
          { "id": "met.inhoud-glasinhoud-onderschat", "label": "Denkt dat een glas 50 ml is (shotglas)", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "MET-INH-SCHATTEN-004",
      "familyId": "MET-INH-SCHATTEN",
      "module": "Metriek",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "inhoud",
      "subSkill": "inhoud_schatten",
      "questionType": "multiple_choice",
      "question": "Welk voorwerp heeft een inhoud van ongeveer 10 liter?",
      "context": null,
      "options": ["Een glas water", "Een theelepel", "Een zwembad", "Een emmer"],
      "correctAnswer": 3,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Referentiepunten inhoud",
            "content": "Onthoud deze referentiepunten:\n• Theelepel ≈ 5 ml\n• Glas ≈ 250 ml\n• Fles ≈ 1,5 l\n• Emmer ≈ 10 l\n• Badkuip ≈ 150 l\n• Zwembad ≈ 50.000 l",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "inhoud_schatten_emmer",
      "variantIndex": 4,
      "citoDifficulty": 0.22,
      "citoDiscrimination": 0.78,
      "feedback": {
        "explanationText": "Een emmer heeft een inhoud van ongeveer 10 liter. Hoe weet je dat? Vergelijk met andere voorwerpen: een glas is ~0,25 liter (veel kleiner), een badkuip is ~150 liter (veel groter). Een emmer zit daar precies tussenin. Dit is een handig referentiepunt om te onthouden!",
        "solutionSteps": [
          "Beoordeel elk voorwerp met je referentiepunten",
          "Glas ≈ 0,25 liter — veel te klein",
          "Emmer ≈ 10 liter — past! ✓",
          "Zwembad ≈ 50.000 liter — veel te groot"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat een glas water 10 liter bevat. Maar een glas is ~250 ml (0,25 liter) — 40× kleiner dan 10 liter. Onthoud: glas ≈ 250 ml, emmer ≈ 10 liter.",
          "1": "Je dacht waarschijnlijk dat een theelepel 10 liter bevat. Maar een theelepel is ~5 ml (0,005 liter) — 2.000× kleiner! Onthoud: theelepel ≈ 5 ml.",
          "2": "Je dacht waarschijnlijk dat een zwembad 10 liter bevat. Maar een zwembad bevat ~50.000 liter — 5.000× meer dan 10 liter! Onthoud: zwembad ≈ 50.000 liter.",
          "3": "Goed! Een emmer bevat ongeveer 10 liter. Dat is een handig referentiepunt om te onthouden."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "met.inhoud-glas-overschat", "label": "Schat een glas op 10 liter", "optionIndex": 0 },
          { "id": "met.inhoud-theelepel-overschat", "label": "Schat een theelepel op 10 liter", "optionIndex": 1 },
          { "id": "met.inhoud-zwembad-onderschat", "label": "Schat een zwembad op 10 liter", "optionIndex": 2 }
        ]
      }
    },
    {
      "id": "MET-INH-SCHATTEN-005",
      "familyId": "MET-INH-SCHATTEN",
      "module": "Metriek",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "inhoud",
      "subSkill": "inhoud_schatten",
      "questionType": "ordering",
      "question": "Zet deze voorwerpen in volgorde van weinig naar veel inhoud.",
      "context": null,
      "options": [],
      "correctAnswer": 0,
      "data": {
        "items": [
          "Theelepel (~5 ml)",
          "Glas water (~250 ml)",
          "Pak melk (~1 liter)",
          "Emmer (~10 liter)",
          "Badkuip (~150 liter)"
        ],
        "correctOrder": [0, 1, 2, 3, 4]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Inhoud vergelijken",
            "content": "Reken alles om naar dezelfde eenheid (ml):\n• Theelepel ~5 ml\n• Glas ~250 ml\n• Pak melk ~1.000 ml (1 l)\n• Emmer ~10.000 ml (10 l)\n• Badkuip ~150.000 ml (150 l)\nVan klein naar groot: 5 → 250 → 1.000 → 10.000 → 150.000",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "inhoud_schatten_volgorde",
      "variantIndex": 5,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.77,
      "feedback": {
        "explanationText": "Van weinig naar veel: theelepel (5 ml) → glas (250 ml) → pak melk (1 l) → emmer (10 l) → badkuip (150 l). Elk volgend voorwerp bevat ongeveer 5-10× zoveel als het vorige. Waarom is dit handig? Door deze volgorde te kennen, kun je altijd schatten door te vergelijken met het dichtstbijzijnde referentiepunt.",
        "solutionSteps": [
          "Reken alle inhouden om naar ml voor eerlijke vergelijking",
          "Theelepel ≈ 5 ml, glas ≈ 250 ml, pak melk ≈ 1.000 ml",
          "Emmer ≈ 10.000 ml, badkuip ≈ 150.000 ml",
          "Zet op volgorde van klein naar groot: 5 → 250 → 1.000 → 10.000 → 150.000 ✓"
        ]
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "met.inhoud-volgorde-eenheden-fout", "label": "Vergelijkt zonder eerst om te rekenen naar gelijke eenheid" }
        ]
      }
    },
    {
      "id": "MET-INH-SCHATTEN-006",
      "familyId": "MET-INH-SCHATTEN",
      "module": "Metriek",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "inhoud",
      "subSkill": "inhoud_schatten",
      "questionType": "estimation_slider",
      "question": "Schat hoeveel milliliter er in een normaal drinkpak (bijvoorbeeld een pak appelsap voor onderweg) zit.",
      "context": null,
      "options": [],
      "correctAnswer": 0,
      "data": {
        "min": 0,
        "max": 1000,
        "correctValue": 200,
        "tolerancePercent": 20,
        "unit": "ml",
        "showNumberLine": true,
        "showValue": false
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "measuringCup",
          "showWhen": "wrong",
          "data": {
            "maxVolume": 500,
            "currentVolume": 200,
            "unit": "ml",
            "label": "Een klein drinkpak ≈ 200 ml (ongeveer 1 glas)."
          }
        },
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Referentiepunten voor kleine inhouden",
            "content": "Gebruik wat je kent als ankerpunt:\n• Theelepel ≈ 5 ml\n• Klein glas/drinkpak ≈ 200 ml\n• Groot glas ≈ 250 ml\n• Blikje frisdrank ≈ 330 ml\n• Halve fles water ≈ 500 ml\nEen kinderpak appelsap voelt als 'ongeveer één glas' — dus rond de 200 ml.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "inhoud_schatten_drinkpak",
      "variantIndex": 6,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Een klein drinkpak voor onderweg bevat meestal rond de 200 ml — vergelijkbaar met één glas. Sommige zijn iets kleiner (150 ml) of groter (250 ml), maar 200 ml is een goede schatting. Hoe kun je dat schatten? Denk aan een glas water: dat houdt ook ongeveer 200-250 ml in.",
        "solutionSteps": [
          "Denk aan een referentiepunt: een glas ≈ 200-250 ml",
          "Een drinkpak voor onderweg voelt als 'ongeveer één glas'",
          "Schatting: rond de 200 ml",
          "Check: 200 ml past tussen theelepel (5 ml) en halve fles (500 ml) ✓"
        ]
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "met.inhoud-referentie-drinkpak-fout", "label": "Schat drinkpak verkeerd in (verwart met grote fles of klein glaasje)" }
        ]
      }
    }
  ]
}